'use strict';
/* eslint-disable */

/**
 * OG.setProduct should be called when the page loads or when the user selects a different product.
 */
function setProduct() {
	if (window.OG && window.OG.setProduct) {
		var productID = $('.og-offer').data('og-product');
		var productCount = $('.pdpForm .input-group-qty').val();
		var $ogOffer = $('.og-offer[data-og-product="' + productID + '"]');
		var ogModule = $ogOffer.length ? $ogOffer.attr('data-og-module') : 'pdp';
		window.OG.setProduct({
			id: productID,
			module: ogModule,
			quantity: productCount
		});
	}
}

/**
 * Informs OG a product quantity has changed
 */
function setQuantity() {
	var productID = $('.og-offer').data('og-product');
	var productCount = $('.pdpForm .input-group-qty').val();
	var $ogOffer = $('.og-offer[data-og-product="' + productID + '"]');
	var ogModule = $ogOffer.length ? $ogOffer.attr('data-og-module') : 'pdp';
	window.OG.setQuantity({
		id: productID,
		quantity: productCount,
		module: ogModule
	});
}

/**
 * Informs OG a product is added to the cart
 */
function addToCart($form) {
	var $localForm = $form || $('form.pdpForm');
	var productID = $localForm.find('.og-offer').data('og-product');
	var productCount = $localForm.find('.input-group-qty').val();
	var $ogOffer = $('.og-offer[data-og-product="' + productID + '"]');
	var ogModule = $ogOffer.length ? $ogOffer.attr('data-og-module') : 'pdp';
	window.OG.addToCart([
		{
			id: productID,
			quantity: productCount,
			module: ogModule
		}
	]);
}

module.exports = {
		setProduct: setProduct,
		setQuantity: setQuantity,
		addToCart: addToCart
};
